import { Form } from "antd"
import { Input, Button, TextTag as Text, Logo } from "../../atoms"
import { withFormik } from "formik"
import React from "react"
import { connect } from "react-redux"
import logo from "../../assets/images/logo.svg"
import config from "../../config"
import "./ForgotPassword.scss"
import { ForgotPasswordEmailValidation } from "../../validationSchema/EmailSigninSignupValidation"
import {
  EMAIL_PLACEHOLDER,
  EMAIL_SENT_TO_RESET_PASSWORD,
  FORGOT_PASSWORD_DISCLAIMER,
  PASSWORD_RESET_TITLE,
  SEND_EMAIL_BUTTON,
  PRODUCT_NAME,
} from "../../constants/messages"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import DjangoCSRFToken from "django-react-csrftoken"

const FormItem = Form.Item

class S extends React.PureComponent {
  render() {
    const {
      values,
      handleChange,
      handleBlur,
      touched,
      errors,
      isSubmitting,
      isValid,
      dirty,
    } = this.props

    return (
      <div id="VerifyEmail">
        <div>
          <div></div>
          <div></div>
        </div>
        <div className="outer-container">
          <div></div>
          <div className="verify-email">
            <div className="title-text">
              <Text textType="spaceName">{PASSWORD_RESET_TITLE}</Text>{" "}
            </div>
            {this.props.match.params.success === "success" ? (
              <div className="title-text-info">
                <p></p>
                <Text textType="sectionTextPrimary">
                  {EMAIL_SENT_TO_RESET_PASSWORD}
                </Text>
              </div>
            ) : (
              <div>
                <div className="title-text-info">
                  <Text textType="sectionTextPrimary">
                    {FORGOT_PASSWORD_DISCLAIMER}
                  </Text>
                </div>
                <form
                  action={config.baseUrl + ENDPOINTS.FORGOT_PASSWORD_URL}
                  method="post"
                >
                  <DjangoCSRFToken />
                  <FormItem
                    // help={touched.email && errors.email ? errors.email : ""}
                    validateStatus={
                      touched.email && errors.email ? "error" : undefined
                    }
                  >
                    <Input
                      name="email"
                      placeholder={EMAIL_PLACEHOLDER}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      error={touched.email && errors.email ? errors.email : ""}
                    />
                  </FormItem>
                  <FormItem>
                    <Button
                      btnSize="large"
                      htmlType="submit"
                      className="login-form-button"
                      disabled={isSubmitting || !dirty || !isValid}
                    >
                      {SEND_EMAIL_BUTTON}
                    </Button>
                  </FormItem>
                </form>
              </div>
            )}
          </div>
          <div></div>
        </div>
      </div>
    )
  }
}

export const VerifyEmail = withFormik({
  validationSchema: ForgotPasswordEmailValidation,
  mapPropsToValues: () => ({
    email: "",
    password: "",
  }),
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {},
})(S)

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps, {})(VerifyEmail)
